import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import adminApi from "../../services/adminApi";
import { buildAppPath } from "../../utils/constants";
import toast from "react-hot-toast";
import "../../styles/global.css";
import "../../styles/Admin.css";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If already logged in, redirect to dashboard
    const existingToken = localStorage.getItem("adminToken");
    if (existingToken && !window.location.search.includes("token=")) {
      navigate("/admin/dashboard");
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      setLoading(true);
      adminApi
        .post("/admin/auth/verify", { token })
        .then((res) => {
          localStorage.setItem("adminToken", res.data.token);
          toast.success("Admin login successful");
          window.history.replaceState(
            {},
            document.title,
            buildAppPath("/admin/login")
          );
          navigate("/admin/dashboard");
        })
        .catch(() => toast.error("Invalid or expired link"))
        .finally(() => setLoading(false));
    }
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminApi.post("/admin/auth/request", { email });
      toast.success("Magic link sent if email matches admin");
    } catch (_) {
      toast.error("Failed to send link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 420, margin: "64px auto" }}>
      <div className="card">
        <div
          className="admin-page-header"
          style={{ borderBottom: "none", paddingBottom: 0, marginBottom: 24 }}
        >
          <h2 className="admin-page-title" style={{ fontSize: 24 }}>
            Admin Login
          </h2>
        </div>
        <form onSubmit={onSubmit}>
          <div className="admin-form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div
            className="admin-form-actions"
            style={{ marginTop: 24, paddingTop: 0, borderTop: "none" }}
          >
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
              style={{ width: "100%" }}
            >
              {loading ? "Please wait..." : "Send magic link"}
            </button>
          </div>
        </form>
        {loading && (
          <p className="text-muted text-center mt-2">Processing...</p>
        )}
      </div>
    </div>
  );
}
